<template>
  <el-dialog
    append-to-body
    title="Chọn phòng"
    :close-on-click-modal="false"
    :visible="true"
    width="900px"
    @close="$emit('close')"
  >
    <!-- <div class="content-container"> -->
    <div class="content-box">
      <search-comp @onSearch="fnSearchRoomList" @onReset="onReset">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="w-25">
                  <div class="">
                    <div class="label">Số phòng</div>
                    <div class="child-w-80">
                      <input v-model="searchParams.roomNumber" type="text" />
                    </div>
                  </div>
                </div>
                <div class="w-33">
                  <div class="">
                    <div class="label">Ngày đến</div>
                    <div class="das-layout gap-10">
                      <div class="l-w-66">
                        <CalendarSelect
                          v-model="searchParams.arriveDate"
                          disabled
                          style="display: block; width: 100%"
                          mode="date"
                        />
                      </div>
                      <div class="l-w-33">
                        <TimePicker
                          v-model="searchParams.arrive_time"
                          format="HH:mm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-33">
                  <div class="">
                    <div class="label">Ngày đi</div>
                    <div class="das-layout gap-10">
                      <div class="l-w-66">
                        <CalendarSelect
                          v-model="searchParams.departDate"
                          disabled
                          style="display: block; width: 100%"
                          mode="date"
                        />
                      </div>
                      <div class="l-w-33">
                        <TimePicker
                          v-model="searchParams.depart_time"
                          format="HH:mm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-row">
                <div class="w-25">
                  <div class="">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelId"
                        clearable
                        style="flex: 1"
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="(item, index) in hotelList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="w-25">
                  <div class="">
                    <div class="label">Hạng phòng</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.roomLevelId"
                        style="flex: 1"
                        placeholder="Chọn"
                        clearable
                      >
                        <el-option
                          v-for="item in roomLevelList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="w-25">
                  <div class="">
                    <div class="label">Trạng thái</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.status"
                        clearable
                        style="flex: 1"
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="(item, index) in statusList"
                          :key="index"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="w-25">
                  <div class="">
                    <div class="label">Khác</div>
                    <div class="child-w-80">
                      <div class="checkbox-wrap pr-1">
                        <input
                          id="searchParams.onlyAvailable"
                          v-model="searchParams.onlyAvailable"
                          type="checkbox"
                          disabled
                        />
                        <label for="searchParams.onlyAvailable">{{
                          'Chỉ những phòng có thể đặt'
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </search-comp>
      <div class="section-box">
        <div class="das-form-container">
          <div class="das-form-group" style="height: 300px">
            <GridVx
              ref="roomTable"
              dom-layout="scroll"
              :columns="roomColumns"
              :rows="roomRows"
              class="agGrid"
              :auto-size-cell="true"
              @selectionChanged="onSelectRoom"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small" @click="fnAssignRoom">
          Xác nhận
        </button>
        <button class="btn primary small outline" @click="$emit('close')">
          Đóng
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
// import moment from 'moment'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderCheckboxReadonly } from '@/utils/groupCellRenders.js'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import {
  getHotelListApi,
  getRoomListApi
} from '@/api/booking_service/bookingGroup'
import paginationMixin from '@/mixins/paginationMixin'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    CalendarSelect
  },
  mixins: [paginationMixin],
  props: {
    hotels: {
      required: true,
      default: []
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      roomLoading: false,

      // filter, option for search room order
      hotelList: [],
      roomLevelList: [],
      statusList: ['VD', 'VC', 'VCI', 'OD', 'OC', 'OCI', 'OOS', 'OOO'],
      searchParams: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        arriveDate: null,
        departDate: null,
        onlyAvailable: true,
        arrive_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        }
      },
      searchParamsDefault: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        // arriveDate: null,
        // departDate: null,
        onlyAvailable: true
      },
      roomColumns: [
        {
          headerName: 'Khách sạn',
          field: 'hotel_id',
          valueFormatter: params => {
            return this.hotels.find(hotel => hotel.id === params.value)?.name
          }
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_name'
        },
        {
          headerName: 'Số phòng',
          field: 'room_num'
        },
        {
          headerName: 'Thuộc tính phòng',
          field: 'room_properties'
        },
        {
          headerName: 'Trạng thái buồng phòng',
          field: 'chamber_status'
        },
        {
          headerName: 'Bị chiếm',
          field: 'is_taken',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          // width: 100,
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      roomRows: [],
      selectedRoom: null
    }
  },
  watch: {
    selectedData: {
      deep: true,
      handler(val) {
        if (val) {
          console.log(val)
        }
      }
    }
  },
  async mounted() {
    this.searchParams = JSON.parse(JSON.stringify(this.selectedData))
    this.searchParams.onlyAvailable = true
    await this.fnSearchRoomList()
  },
  async beforeMount() {
    await Promise.all([this.fnGetHotelListApi(), this.getRoomLevelOptions()])
  },
  methods: {
    SelectInputChange(colName, data, value) {
      // console.log('colName', colName, value)
      const idx = data.rowIndex
      this.guestRows[idx][colName] = value
    },

    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      this.guestRows[idx][colName] = value
    },

    changeCheckbox(colName, params, value) {
      const idx = params.rowIndex
      this.guestRows[idx][colName] = value
    },

    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
      this.guestRows[idx][colName] = value
      // console.log(this.rows[params.rowIndex])
    },
    fnAssignRoom(value) {
      this.$emit('roomSelected', this.selectedRoom)
    },
    // assign room pop up filter
    async fnGetHotelListApi() {
      await getHotelListApi()
        .then(res => {
          this.hotelList = res.data
          // this.masterGroupPaging.totalPage = Math.ceil(
          //   res.total / this.searchParams.pageSize
          // )
          // this.masterGroupPaging.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
    },
    async fnSearchRoomList() {
      this.roomLoading = true
      Object.keys(this.searchParams).forEach(key => {
        if (this.searchParams[key] == null || this.searchParams[key] === '') {
          delete this.searchParams[key]
        }
      })
      const params = JSON.parse(JSON.stringify(this.searchParams))
      params.departDate = `${params.departDate} ${params.depart_time.HH}:${params.depart_time.mm}`
      params.arriveDate = `${params.arriveDate} ${params.arrive_time.HH}:${params.arrive_time.mm}`
      delete params.arrive_time
      delete params.depart_time
      await getRoomListApi(params)
        .then(res => {
          this.roomRows = res.data
          this.$message({
            type: 'success',
            message: 'Đã cập nhật danh sách phòng'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.roomLoading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign(
        this.searchParams,
        this.searchParamsDefault
      )
    },
    onSelectRoom(select) {
      this.selectedRoom = select[0]
    }
  }
}
</script>

<style scoped>
.w-0 {
  width: 0%;
}

.w-50 {
  width: 50%;
}

.w-25 {
  width: 33%;
}

.w-25 {
  width: 25%;
}

.close-btn {
  padding-top: 10px;
}

.guest-list::v-deep .ag-cell {
  overflow: visible !important;
}

.guest-list::v-deep .ag-row-focus {
  z-index: 1;
}
</style>
